// For Firebase JS SDK v7.20.0 and later, measurementId is optional
var firebaseConfig = {
  apiKey: "AIzaSyCIaEoYRzuPdQYRvrsxjRbF5t122LtxoMA",
  authDomain: "by-louise.firebaseapp.com",
  databaseURL: "https://by-louise-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "by-louise",
  storageBucket: "by-louise.appspot.com",
  messagingSenderId: "476834812620",
  appId: "1:476834812620:web:781ffcc1cd0b4cde57a869",
  measurementId: "G-DGNJ6KTJTL"
};

firebase.initializeApp(firebaseConfig);
var database = firebase.database();


function formatLikes(likes) {
  if (likes >= 1000000) {
    return (likes / 1000000).toFixed(1) + 'M';
  } else if (likes >= 1000) {
    return (likes / 1000).toFixed(1) + 'K';
  } else {
    return likes;
  }
}

function createHeartAnimation(imageContainer) {
  
  var heartContainer = document.createElement('div');
  heartContainer.classList.add('heart-container');

  var heartIcon = document.createElement('div');

heartIcon.innerHTML = `
    <svg width="50" height="50" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" >
        <g class="heart-container">
            <path class="heart-animation" d="M12 4.248C8.852-1.154 0.7-.917 0.7 6.183 0.7 10.259 5.834 12.5 12 21c6.166-8.5 11.3-10.741 11.3-14.817 0-7.1-8.152-7.336-11.3-1.935z"/>
        </g>
    </svg>
`;

  imageContainer.appendChild(heartIcon);

  setTimeout(function () {
    imageContainer.removeChild(heartIcon);
  }, 2000);
}


document.addEventListener('DOMContentLoaded', function () {
  var likeButtons = document.querySelectorAll('.like-button');

  likeButtons.forEach(function (button) {
    var sku = button.dataset.sku;
var imageContainer = button.closest('.gallery__item-content');
    var counter = button.querySelector('.like-counter');

    // Récupérer le nom de la collection à partir de l'URL
    var path = window.location.pathname; // '/pages/evasao'
    var collectionName = path.split('/')[2]; // 'evasao'

    var likesRef = database.ref(`likes/${collectionName}/${sku}`);

  // Récupérer la valeur actuelle des "J'aime" à partir de Firebase
likesRef.on('value', function (snapshot) {
  var currentCount = snapshot.val() || 0;
  
  // Vérifie si la valeur actuelle des likes est supérieure à 0
  if (currentCount > 0) {
    counter.textContent = formatLikes(currentCount);
  } else {
    counter.textContent = "";  // ou vous pouvez mettre ici tout autre texte par défaut
  }

  counter.dataset.likes = currentCount;
});

    if (!button.dataset.eventAdded) {
      button.addEventListener('click', function () {
        if (button.dataset.liked === "false") {
          if (button.dataset.animated === "true") {
           createHeartAnimation(imageContainer);
          }
          var currentCount = parseInt(counter.dataset.likes);
          var newCount = currentCount + 1;

          // Mettre à jour la valeur des "J'aime" dans Firebase
          likesRef.set(newCount);

          // Mettre à jour l'état du bouton "J'aime"
          button.dataset.liked = "true";
          button.querySelector('i').classList.remove('far');
          button.querySelector('i').classList.add('fas');
        }
      });
      button.dataset.eventAdded = true;
    }

    // Ajoutez un écouteur d'événements pour le double-clic sur l'image
    imageContainer.addEventListener('dblclick', function () {
              // Affichez l'animation du cœur
      if (button.dataset.animated === "true") {
        createHeartAnimation(imageContainer);
      }
      if (button.dataset.liked === "false") {
        var currentCount = parseInt(counter.dataset.likes);
        var newCount = currentCount + 1;

        // Mettre à jour la valeur des "J'aime" dans Firebase
        likesRef.set(newCount);

        // Mettre à jour l'état du bouton "J'aime"
        button.dataset.liked = "true";
        button.querySelector('i').classList.remove('far');
        button.querySelector('i').classList.add('fas');
      }
    });
  });
});
